import { call, put, takeEvery } from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACT from "./actions";
import {  getContentApi } from "helpers/backend_helper";

import {errorMsg, successMsg} from "helpers/toastr";

 /**
      * Used for calling privacy-policy and terms-conditions  api
      */


function* getContentSaga({ payload: { data, callback } }) {
  try {
    const response = yield call(getContentApi, data);
    callback && callback(response);

    if (response.status == "failure") {
      return yield put(ACT.getContentFail(response.message));
    }
    yield put(ACT.getContentSuccess(response));
  } catch (error) {
    yield put(ACT.getContentFail(error));
  }
}



function* contentSaga() {
  yield takeEvery(CONST.GET_CONTENT, getContentSaga);
}

export default contentSaga;
